import { defineAsyncComponent } from "vue";

export default {
    sectionContainer: defineAsyncComponent(() => import("./SectionContainer.vue")),
    webButton: defineAsyncComponent(() => import("./WebButton.vue")),
    // Full hero-shell override — always boxed/capped, no scroll-pin effect.
    hero: defineAsyncComponent(() => import("./Hero.vue")),
    card: defineAsyncComponent(() => import("./Card.vue")),
    tokens: {
        "--theme-tracking": "-0.02em",
        "--theme-modal-bg": "rgba(0,0,0,0.75)",
        "--theme-modal-blur": "none",
    },
};
